import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { SaleOrderList } from '../../TitleList';
import { fetchSORegister } from '../../../Store/PHPSlice/Sale/SaleOrder';
import { selectSOlistReg } from '../../Selectors/Master/ItemSelectors';


const SaleOrderTable = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    const saleordlist = useSelector(selectSOlistReg);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchSORegister());
    }, [dispatch]);


    const compData = Array.isArray(saleordlist.data) ? saleordlist?.data?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            sono: item.sono,
            entry_type: item.entry_type,
            ordt: item.ordt,
            quotNo: item.quotNo,
            firmNm: item.firmNm,
            partyNm: item.partyNm,
            itemNm: item.itemNm,
            grpNm: item.grpNm,
            schoolNm: item.schoolNm,
            mclothNm: item.mclothNm,
            m1clothNm: item.m1clothNm,
            m2clothNm: item.m2clothNm,
            m3clothNm: item.m3clothNm,
            totQty: item.totQty,
            cltsts: item.cltsts,
            barcode: item.barcode,
            orderno: item.orderno,
            userId: item.userid,
            userNm: item.userNm,
        }
    )) : [];

    // console.log(saleordlist);
    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.sono?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.itemNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.barcode?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    const headCells = [
        { id: 'info', label: 'Info' },
        { id: 'minfo', label: 'Material' },
        { id: 'excel', label: 'Excel' },
        { id: 'srno', label: 'SrNo' },
        { id: 'ordt', label: 'Date' },
        { id: 'entry_type', label: 'Entry Type' },
        { id: 'firm', label: 'Firm' },
        { id: 'sono', label: 'SO No' },
        { id: 'quotNo', label: 'Quot. No.' },
        { id: 'orderno', label: 'Order No.' },
        { id: 'partyNm', label: 'Party' },
        // { id: 'itemNm', label: 'Item' },
        // { id: 'maincloth', label: 'Cloth' },
        // { id: 'm1clothNm', label: 'Match1' },
        // { id: 'm2cloth', label: 'Match2' },
        // { id: 'm3cloth', label: 'Match3' },
        { id: 'totQty', label: 'Qty' },
        { id: 'schoolNm', label: 'School' },
        { id: '', label: 'Cloth Issue' },
        { id: '', label: 'Edit' },
        { id: '', label: 'Delete' },

    ];

    if (userdata?.role === "1") {
        headCells.push({ id: 'userNm', label: 'User' });
    }
    return (
        <>
            <Titlebar data={SaleOrderList} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Order Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />

                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={headCells}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>

                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                serialNumber={row.serialNumber}
                                                ordt={row.ordt}
                                                sono={row.sono}
                                                quotNo={row.quotNo}
                                                orderno={row.orderno}
                                                entry_type={row.entry_type}
                                                firmNm={row.firmNm}
                                                partyNm={row.partyNm}
                                                // itemNm={row.itemNm}
                                                grpNm={row.grpNm}
                                                // mclothNm={row.mclothNm}
                                                // m1clothNm={row.m1clothNm}
                                                // m2clothNm={row.m2clothNm}
                                                // m3clothNm={row.m3clothNm}
                                                barcode={row.barcode}
                                                totQty={row.totQty}
                                                schoolNm={row.schoolNm}
                                                cltsts={row.cltsts}
                                                userId={row.userId}
                                                userNm={row.userNm}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            {/* <Pagination
                                currentPage={currentPage}
                                npages={npages}
                                handlePrevPage={handlePrevPage}
                                handleNextpage={handleNextpage}
                                setCurrentPage={setCurrentPage}
                                renderPaginationButtons={renderPaginationButtons}
                                totalCount={totalCount}
                            /> */}

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default SaleOrderTable;
